import { createRequestTypes } from 'common/websocket-redux';

export const LOAD_QUICK_ACTIONS = createRequestTypes(
  'member/LOAD_QUICK_ACTIONS',
);

export const loadQuickActions = () => ({
  type: LOAD_QUICK_ACTIONS.BASE,
});
